<template>
    <div class="payout">

        <pageheader :text="heading"/>


        <div v-if="!user" class="text-center  my-2" >
            <b-spinner class="align-middle"></b-spinner>
            <strong> Laster...</strong>
        </div>
        <div v-else-if="user && !user.bankaccount">
            <p>
                For å få penger utbetalt må du ha lagt inn kontoummer og verifisert bankkontoen med BankID.
            </p>

            <b-button variant="primary" to="/bankkonto">Legg inn bankkonto</b-button>

        </div>

        <div v-else-if="success != true">
            <p>
                Bruk hurtigtastene eller skriv inn beløpet du ønsker å ta ut fra spillekontoen din. Deretter bekrefter du vilkårene og trykker 'Sett til utbetaling'.

                Maks utbetaling: <strong>{{user.balance}},-</strong>
            </p>

            <b-form @submit="onSubmit">

                <div class="payoutDetails mb-5">

                    <div class="mb-3">
                        <b-badge v-for="a in amounts" :key="a" @click="amountSelected(a)" href="#" class="transferAmount" variant="primary">{{a}},-</b-badge>
                        <b-badge @click="amountSelected(user.balance)" href="#" class="transferAmount" variant="secondary">{{user.balance}},-</b-badge>
                    </div>

                    <b-form-group>
                        <b-input-group  prepend="kr" append=",-" class="w-50">
                            <b-form-input v-model="form.amount" type="number" number min="0" placeholder="Beløp"></b-form-input>
                        </b-input-group>
                    </b-form-group>

                    <div class="payment-info">
                        <p class="text-muted">Utbetalingen blir gjort via vår bank til din konto <strong>{{ bankaccount }}</strong> og kan ta <strong>1-2 dager</strong>.</p>
                    </div>

                </div>


                <hr>



                <b-form-group>
                    <b-form-checkbox  v-model="form.wantsNotification" name="notification" id="notification">
                        Jeg vil bli varslet når utbetalingen er sendt til banken.
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group v-if="form.wantsNotification && !user.email">
                    <b-input-group class="w-50">
                        <b-form-input v-model="form.email" type="email" autocomplete="email" placeholder="E-post"></b-form-input>
                    </b-input-group>
                </b-form-group>

                <div class="notification-info" v-if="form.wantsNotification">
                    <p class="text-muted">Varsling blir sendt til {{user.email ? user.email: form.email}} når den går til banken.</p>
                </div>


                <div class="mb-4">
                    <b-form-checkbox  v-model="form.acceptedTerms" name="terms"  id="terms">
                        Jeg bekrefter <b-link variant="link" v-b-modal.termsModal>vilkårene</b-link>
                    </b-form-checkbox>
                </div>



                <b-alert show variant="danger" v-if="errors.length" class="errors">

                    <ul>
                        <li v-for="error in errors" :key="error">
                            {{ error }}
                        </li>
                    </ul>
                </b-alert>

                <b-button type="submit" variant="primary">Sett til utbetaling</b-button>

            </b-form>


        </div>

        <div v-else >

            <p>
                Din betaling er mottatt og blir behandlet av oss så snart som mulig.
            </p>

            <p>
                Du kan se transaksjonen i <router-link to="/transaksjoner">oversikten.</router-link>
            </p>

        </div>



        <b-modal id="termsModal" centered size="lg" title="Betalingsvilkår">

            <h2>Hvordan fyller du på spillekontoen din?</h2>
            <p>
                For å kunne spille på nett må du ha tilgjengelig kreditt på
                spillekontoen din. Dette kan gjøres lokalt på den bingoen
                du opprettet medlemskap på, eller inne på norskbingo.no
                med visa, mastercard eller vipps.
            </p>

            <h2>Angrerett på innsatt beløp til spillekonto!</h2>
            <p>
                Tilgjengelig beløp på din spillekonto kan når som helst tas
                ut  igjen ved å oppsøke den bingoen du har medlemskap
                og spillekonto hos. Det er ingen krav til å måtte spille noe
                av den kreditten som er satt inn på spillekontoen.
            </p>


            <h2>Angrerett på kjøp av spillebonger!</h2>
            <p>
                Kjøpte bonger kan angres helt frem til spillet har startet
                ved å trykke avbryt kjøp. Kjøpet er ikke avbrutt dersom
                kjøpte bonger ikke er fjernet fra skjermen og pengene
                returnert til spillekonto.
            </p>

            <h2>Blokker deg for spill!</h2>
            <p>
                Du kan når som helst blokkere deg selv ute fra spill på
                vår nettside. Hvis du tar dette valget vil du være
                utestengt for spill for 1 år. Du kan fortsatt gå til den
                bingoen du har medlemskap på, å ta ut tilgjengelig
                kreditt på din spillekonto. Ved å stenge deg ute fra
                nettspill hindrer deg ikke i å spille hos din lokale bingo.
            </p>
        </b-modal>




    </div>
</template>

<script>

// @ is an alias to /src
export default {
    name: 'Payout',
    components: {

    },
    data() {
        return {
            success: null,
            user: null,

            amounts: [
                500,
                1000,
                2000,
                4000,
                8000
            ],
            form: {
                amount: null,
                email: null,
                acceptedTerms: false,
                wantsNotification: true
            },
            errors:[],
        }
    },

    mounted() {

        // Get user data
        this.$api.get(`/users/${this.$store.getUser().card_id}/`)
        .then((response) => {
            // Fil form
            this.user = response.data.data
        })
        .catch((response) => {
            console.log(response);
        });


    },


    methods: {
        amountSelected(amount) {
            this.form.amount = amount
        },
        onSubmit(e) {
            e.preventDefault()

            this.errors = []

            if (!this.form.amount) this.errors.push('Verdi mangler.')
            if (this.form.amount <= 0) this.errors.push('Verdi må være positiv.')
            if (this.form.amount > this.user.balance) this.errors.push(`Verdi må være mindre eller lik enn saldo (${this.user.balance},-)`)
            if (!this.form.acceptedTerms) this.errors.push('Du må akseptere vilkårene.')

            if (this.form.wantsNotification && !this.user.email && !this.form.email) this.errors.push('Du må skrive inn en e-post.')

            if (this.errors.length) return;

            var postData = {
                amount: this.form.amount,
                notification: this.form.wantsNotification,
            };
            // Add email if user want notification and does not have an email from before
            if (this.form.wantsNotification && !this.user.email && this.form.email) postData.email = this.form.email;

            this.$api.post(`/users/${this.$store.getUser().card_id}/payouts/`, postData)
            .then((response) => {
                this.success = true;
            })
            .catch((error) => {
                console.log(error);
                if (error.response) {
                    let code = error.response.status;

                    if (code == 400) {
                        this.errors.push('Vi kunne ikke registrere betalingen din.')
                    }
                    else {
                        this.errors.push('En ukjent feil har oppstått. Kontakt support.')
                    }
                }
                console.log(error);
            });


        },
    },
    computed: {
        heading: function() {
            if (this.user) return `Ta ut penger fra ${this.user.hall.owner.name} (${this.user.hall.owner.orgnum})`;
            else return "Ta ut penger fra ...";
        },
        bankaccount: function() {
            if (this.user) return this.user.bankaccount;
            else return "...";
        }
    }
}

</script>


<style lang="scss">

.transferAmount {
    font-size: 1.5em;
    margin-right: 0.5em;
    margin-top: 0.5em;
}
.errors {
    font-size: 0.8em;
    margin-top: 2em;
}


#termsModal h2 {
    font-size: 1.2em;

}

</style>
